/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './route-logged.component.less.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../custom/header-xs/header-xs.component.ngfactory';
import * as i3 from '../../../../app/custom/header-xs/header-xs.component';
import * as i4 from '../../../../app/core/app-memory.service';
import * as i5 from '@angular/router';
import * as i6 from '../../custom/nav/nav.component.ngfactory';
import * as i7 from '../../../../app/custom/nav/nav.component';
import * as i8 from '../../../../app/core/get.service';
import * as i9 from '../../../../app/auth/auth.service';
import * as i10 from '../../custom/header/header.component.ngfactory';
import * as i11 from '../../../../app/custom/header/header.component';
import * as i12 from '../../custom/activity/activity.component.ngfactory';
import * as i13 from '../../../../app/custom/activity/activity.component';
import * as i14 from '../../../../app/core/route-logged/route-logged.component';
const styles_RouteLoggedComponent:any[] = [i0.styles];
export const RenderType_RouteLoggedComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_RouteLoggedComponent,data:{}});
export function View_RouteLoggedComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),19,'div',[['class',
      'wrapper']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(-1,(null as any),['\n  '])),(_l()(),i1.ɵeld(2,0,(null as any),
          (null as any),1,'app-header-xs',([] as any[]),(null as any),(null as any),
          (null as any),i2.View_HeaderXsComponent_0,i2.RenderType_HeaderXsComponent)),
      i1.ɵdid(3,4440064,(null as any),0,i3.HeaderXsComponent,[i4.AppMemoryService,
          i5.Router,i5.ActivatedRoute],(null as any),(null as any)),(_l()(),i1.ɵted(-1,
          (null as any),['\n  '])),(_l()(),i1.ɵeld(5,0,(null as any),(null as any),
          1,'app-nav',[['class','nav-main']],(null as any),[['window','resize']],(_v,
              en,$event) => {
            var ad:boolean = true;
            if (('window:resize' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,6).resizedWindow($event.currentTarget)) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i6.View_NavComponent_0,i6.RenderType_NavComponent)),i1.ɵdid(6,114688,(null as any),
          0,i7.NavComponent,[i4.AppMemoryService,i8.GetService,i9.AuthService,i5.Router,
              i1.ChangeDetectorRef],(null as any),(null as any)),(_l()(),i1.ɵted(-1,
          (null as any),['\n  '])),(_l()(),i1.ɵeld(8,0,(null as any),(null as any),
          10,'div',[['class','main logged']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n    '])),
      (_l()(),i1.ɵeld(10,0,(null as any),(null as any),1,'app-header',[['class','header']],
          (null as any),(null as any),(null as any),i10.View_HeaderComponent_0,i10.RenderType_HeaderComponent)),
      i1.ɵdid(11,245760,(null as any),0,i11.HeaderComponent,[i4.AppMemoryService,i8.GetService,
          i9.AuthService,i5.Router,i5.ActivatedRoute],(null as any),(null as any)),
      (_l()(),i1.ɵted(-1,(null as any),['\n    '])),(_l()(),i1.ɵeld(13,0,(null as any),
          (null as any),1,'app-activity',([] as any[]),(null as any),(null as any),
          (null as any),i12.View_ActivityComponent_0,i12.RenderType_ActivityComponent)),
      i1.ɵdid(14,114688,(null as any),0,i13.ActivityComponent,[i4.AppMemoryService],
          (null as any),(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n    '])),
      (_l()(),i1.ɵeld(16,16777216,(null as any),(null as any),1,'router-outlet',([] as any[]),
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      i1.ɵdid(17,212992,(null as any),0,i5.RouterOutlet,[i5.ChildrenOutletContexts,
          i1.ViewContainerRef,i1.ComponentFactoryResolver,[8,(null as any)],i1.ChangeDetectorRef],
          (null as any),(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n  '])),
      (_l()(),i1.ɵted(-1,(null as any),['\n'])),(_l()(),i1.ɵted(-1,(null as any),['\n']))],
      (_ck,_v) => {
        _ck(_v,3,0);
        _ck(_v,6,0);
        _ck(_v,11,0);
        _ck(_v,14,0);
        _ck(_v,17,0);
      },(null as any));
}
export function View_RouteLoggedComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'app-route-logged',
      ([] as any[]),(null as any),(null as any),(null as any),View_RouteLoggedComponent_0,
      RenderType_RouteLoggedComponent)),i1.ɵdid(1,114688,(null as any),0,i14.RouteLoggedComponent,
      ([] as any[]),(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const RouteLoggedComponentNgFactory:i1.ComponentFactory<i14.RouteLoggedComponent> = i1.ɵccf('app-route-logged',
    i14.RouteLoggedComponent,View_RouteLoggedComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUvdnN0cy93b3JrLzEvcy9lbXItd2ViYXBwL3NyYy9hcHAvY29yZS9yb3V0ZS1sb2dnZWQvcm91dGUtbG9nZ2VkLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9ob21lL3ZzdHMvd29yay8xL3MvZW1yLXdlYmFwcC9zcmMvYXBwL2NvcmUvcm91dGUtbG9nZ2VkL3JvdXRlLWxvZ2dlZC5jb21wb25lbnQudHMiLCJuZzovLy9ob21lL3ZzdHMvd29yay8xL3MvZW1yLXdlYmFwcC9zcmMvYXBwL2NvcmUvcm91dGUtbG9nZ2VkL3JvdXRlLWxvZ2dlZC5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2hvbWUvdnN0cy93b3JrLzEvcy9lbXItd2ViYXBwL3NyYy9hcHAvY29yZS9yb3V0ZS1sb2dnZWQvcm91dGUtbG9nZ2VkLmNvbXBvbmVudC50cy5Sb3V0ZUxvZ2dlZENvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxkaXYgY2xhc3M9XCJ3cmFwcGVyXCI+XG4gIDxhcHAtaGVhZGVyLXhzPjwvYXBwLWhlYWRlci14cz5cbiAgPGFwcC1uYXY+PC9hcHAtbmF2PlxuICA8ZGl2IGNsYXNzPVwibWFpbiBsb2dnZWRcIj5cbiAgICA8YXBwLWhlYWRlcj48L2FwcC1oZWFkZXI+XG4gICAgPGFwcC1hY3Rpdml0eT48L2FwcC1hY3Rpdml0eT5cbiAgICA8cm91dGVyLW91dGxldD48L3JvdXRlci1vdXRsZXQ+XG4gIDwvZGl2PlxuPC9kaXY+XG4iLCI8YXBwLXJvdXRlLWxvZ2dlZD48L2FwcC1yb3V0ZS1sb2dnZWQ+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O29CQ0FBO01BQUE7TUFBcUIsNENBQ25CO1VBQUE7VUFBQTthQUFBO3FDQUFBLCtCQUErQjtVQUFBLHlCQUMvQjtVQUFBO3VCQUFBO1lBQUE7WUFBQTtjQUFBO2NBQUE7WUFBQTtZQUFBO1VBQUEsNkRBQUE7VUFBQTtrQ0FBQSwrQkFBbUI7VUFBQSx5QkFDbkI7VUFBQTtVQUFBLDhCQUF5QjtNQUN2QjtVQUFBO2FBQUE7b0RBQUE7TUFBeUIsOENBQ3pCO1VBQUE7VUFBQTthQUFBO1VBQUEsNkJBQTZCO01BQzdCO1VBQUE7YUFBQTswREFBQTtVQUFBLDZCQUErQjtNQUMzQiwwQ0FDRjs7UUFQSjtRQUNBO1FBRUU7UUFDQTtRQUNBOzs7O29CQ05KO01BQUE7cUNBQUEsVUFBQTtNQUFBO0lBQUE7Ozs7In0=



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/$$_gendir/app/core/route-logged/route-logged.component.ngfactory.ts